import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';

import { recoveryRequest } from '~/store/modules/auth/actions';

import { LoginOutlined, MailOutlined, SendOutlined } from '@ant-design/icons';
import { Card, AppName, Title, ImageContainer, Form, Button, FormItem, Link } from '~/pages/_layouts/auth/styles';
import { Container } from './styles';

import image from '~/assets/images/login.jpg';

export default function Recovery(props) {
  const dispatch = useDispatch();

  const loading = useSelector(store => store.auth.loading);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    const { email } = values;

    dispatch(recoveryRequest(email));
  }

  return (
    <Container>
      <Row style={{ height: '100%' }}>
        <Col xs={24} md={12} lg={11} xl={10} style={{ height: '100%', overflow: 'auto' }}>
          <Card>
            <AppName>
              <hr />
              <div>
                <span>StationUp</span>
                <span>DevOps</span>
              </div>
              <hr />
              <span>Powered by <a href="https://www.webstationdesign.com.br" target="_blank">WebStation</a></span>
            </AppName>

            <Title>Recuperação de senha</Title>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row>
                <Col xs={24}>
                  <p>Informe seu e-mail para receber um link com as informações de recuperação de sua conta.<br /></p>
                </Col>

                <Col xs={24}>
                  <FormItem
                    name="email"
                    rules={[{ required: true, message: 'E-mail é obrigatório' }]}
                  >
                    <div className="input-group">
                      <MailOutlined />
                      <input placeholder="E-mail" />
                    </div>
                  </FormItem>
                </Col>

                <Col xs={24}>
                  <FormItem>
                    <Button
                      shape='aroud'
                      icon={<SendOutlined />}
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      Enviar
                    </Button>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col xs={24} className="col-flex-center" style={{ marginTop: 40, marginBottom: 30 }}>
                  <Link to="/login" className="primary-color">
                    <LoginOutlined />
                    Voltar para Login
                  </Link>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>

        <Col xs={0} md={12} lg={13} xl={14} style={{ height: '100%', overflow: 'hidden' }}>
          <ImageContainer>
            <img src={image} height="120%" />
          </ImageContainer>
        </Col>
      </Row>
    </Container>
  );
}